module.exports = __webpack_public_path__ + "img/837000003_6.970d221f.jpg";